import { ScaleDefinition } from '../../models/dynamic-scale.model';
import { SCALE_TYPE } from '../scale-type.enum';

export const TCT_SCALE: ScaleDefinition = {
  idRef: SCALE_TYPE.TCT,
  title: 'Trunk Control Test (TCT)',
  scoreConfig: {
    scoreKey: 'totale',
    scoreFields: [
      'girarsi_su_lato_sano',
      'girarsi_su_lato_leso',
      'sedersi_in_equilibrio',
      'passaggio_da_seduto_a_letto',
    ],
  },
  sections: [
    {
      name: 'tct',
      label: 'Trunk Control Test',
      fields: [
        // 1
        {
          key: 'girarsi_su_lato_sano',
          label: 'Girarsi sul lato sano',
          type: 'number',
          min: 0,
          max: 25,
          step: 1,
          maxScore: 25,
          valueDescriptions: {
            '0': 'Incapace di completare il movimento.',
            '12': 'Completa il movimento con aiuto.',
            '25': 'Completa il movimento in modo indipendente.',
          },
          description:
            'Valuta la capacità di ruotare il tronco verso il lato sano.',
        },
        // 2
        {
          key: 'girarsi_su_lato_leso',
          label: 'Girarsi sul lato leso',
          type: 'number',
          min: 0,
          max: 25,
          step: 1,
          maxScore: 25,
          valueDescriptions: {
            '0': 'Incapace di completare il movimento.',
            '12': 'Completa il movimento con aiuto.',
            '25': 'Completa il movimento in modo indipendente.',
          },
          description:
            'Valuta la capacità di ruotare il tronco verso il lato affetto.',
        },
        // 3
        {
          key: 'sedersi_in_equilibrio',
          label: 'Mantenere la posizione seduta',
          type: 'number',
          min: 0,
          max: 25,
          step: 1,
          maxScore: 25,
          valueDescriptions: {
            '0': 'Non mantiene la seduta senza supporto.',
            '12': 'Mantiene la seduta con sostegno o per periodi brevi.',
            '25': 'Mantiene la seduta in autonomia e stabilmente.',
          },
          description:
            'Valuta la capacità di mantenere l’equilibrio in posizione seduta.',
        },
        // 4
        {
          key: 'passaggio_da_seduto_a_letto',
          label: 'Passaggio da seduto a sdraiato',
          type: 'number',
          min: 0,
          max: 25,
          step: 1,
          maxScore: 25,
          valueDescriptions: {
            '0': 'Incapace di completare il passaggio.',
            '12': 'Completa il movimento con assistenza.',
            '25': 'Esegue il movimento in autonomia.',
          },
          description:
            'Valuta il controllo del tronco nel passaggio tra seduto e supino.',
        },
      ],
    },
  ],

  computedFields: [
    // TOTALE
    {
      key: 'totale',
      label: 'Totale TCT',
      type: 'number',
      calculation: 'SUM(scoreConfig.sumOf)',
      maxScore: 100,
    },
    // INTERPRETAZIONE AUTOMATICA
    {
      key: 'interpretazione',
      label: 'Interpretazione del risultato',
      type: 'text',
      calculation: `
        IF(totale >= 75, "Buon controllo del tronco",
          IF(totale >= 50, "Controllo del tronco moderato",
            IF(totale >= 25, "Scarso controllo del tronco",
              "Assenza di controllo del tronco"
            )
          )
        )
      `,
      maxScore: 0,
    },
  ],
};
